import { render } from "./RoutePermissionGuard.vue?vue&type=template&id=13dbcdc0"
import script from "./RoutePermissionGuard.vue?vue&type=script&lang=js"
export * from "./RoutePermissionGuard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__